import { FormValues } from '../../../components/Store/reducers/formReducer/types'
import { RegistrationResponse } from '../registrationApi/types'
import { formatters } from '../registrationApi/formatters'

export const fetchJobSeekerRegistration = async (
    data: FormValues,
    registerToken: string
): Promise<RegistrationResponse> => {
    const csrfToken = document.querySelector<HTMLMetaElement>(
        'meta[name="csrf-token"]'
    )?.content
    if (!csrfToken) {
        throw new Error('CSRF token not found')
    }

    try {
        const formattedData = formatters(data)

        const response = await fetch(`/job_seekers/${registerToken}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify({ user: formattedData }),
        })

        if (!response.ok) {
            const contentType = response.headers.get('content-type') || ''
            if (contentType.includes('text/plain')) {
                const errorMessage = await response.text()
                return Promise.reject(new Error(errorMessage))
            }
            return Promise.reject(
                new Error(`HTTP error! status: ${response.status}`)
            )
        }

        const responseData = await response.json()

        if (responseData.status === 'success' && responseData.location) {
            window.location.href = responseData.location
        }
        return responseData
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Registration failed: ${error.message}`)
        }
        throw new Error('Registration failed: Unknown error')
    }
}
